export function getPrettyCost(costCents: number): string {
  const dollars = costCents / 100;
  return `$ ${dollars.toFixed(2)}`;
}
